import Ncookies from 'helpers/ncookies';

const getAuthKey = req => {
  let auth_key;
  if (req && req.headers && req.headers.cookie && req.headers.cookie.indexOf('auth_key=') !== -1) {
    auth_key = req.headers.cookie.split('auth_key=')[1].split(';')[0];
  } else {
    const cookies = new Ncookies();
    auth_key = cookies.get('auth_key');
  }
  return auth_key;
};

export default getAuthKey;



// WEBPACK FOOTER //
// helpers/getAuthKey.js